<script setup lang="ts">
type Props = {
  chevronClass?: string;
  direction?: "up" | "down" | "left" | "right";
  size?: number;
};

const {
  chevronClass = "",
  direction = "down",
  size = 20,
} = defineProps<Props>();

const directions = {
  down: "",
  left: "rotate-90",
  up: "rotate-180",
  right: "rotate-270",
};

const rotation = computed(() => directions[direction]);
</script>

<template>
  <BaseIcon
    name="chevronDown"
    class="transform transition-all"
    :size="size"
    :class="chevronClass + rotation"
  />
</template>
